/**
 * Formatting for the amounts on the Subscriptions and Licences card.
 *
 * Pure and separate from the directive so it can be tested directly — the numbers here
 * are the ones a customer checks their bank statement against.
 */

/**
 * Render a billing amount the way the card shows it, e.g. `CA$13.00 CAD`.
 *
 * The amount is a whole invoice total, not a per-seat rate: the server reads it off the
 * invoice Stripe will issue, which already covers every seat on the subscription. It
 * must not be multiplied by the quantity — doing so used to overstate a multi-seat
 * renewal by a factor of the seat count (issue #547).
 *
 * Returns an empty string only when there is genuinely nothing to show — the server
 * could not establish what the next charge will be — and the caller then hides the line
 * rather than guessing at a figure. A zero charge is a known answer, not a missing one:
 * a fully discounted renewal is worth stating.
 */
export function formatBillingAmount(amount: number | null | undefined, currency: string | null | undefined): string {

    if (amount === null || amount === undefined || !currency) {
        return "";
    }

    try {

        const formattedNumber = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'symbol',
        }).format(amount)

        return `${formattedNumber} ${currency.toUpperCase()}`;

    } catch {
        return `$${amount} ${currency.toUpperCase()}`;
    }
}
